import { AxiosResponse } from 'axios';
import { format } from 'date-fns';
import { all, takeLatest, call, put } from 'redux-saga/effects';
import api from '../../../services/api';
import {
  getOrdersRequest,
  getOrdersSuccess,
  getOrdersFailure,
} from './actions';
import { ActionTypes, IOrdersResponse } from './types';

type GetOrdersRequest = ReturnType<typeof getOrdersRequest>;

export function* getOpenOrders({ payload }: GetOrdersRequest): any {
  const { jwt, user, startDate, status } = payload.input;

  const unitsNames: string[] = [];
  user.units.map(unit => unitsNames.push(unit.id));

  const formattedStart = startDate
    ? format(startDate, 'yyyy-MM-dd')
    : '2021-01-01';

  const response: AxiosResponse<IOrdersResponse> = yield call(
    api.get,
    `/orders/detailed/status/${status}/unit/${unitsNames}/start_from/${formattedStart}`,
    {
      headers: {
        'x-access-token': jwt,
      },
    },
  );

  if (response.data.status === 'success') {
    const data = {
      status,
      orders: response.data.orders,
    };
    yield put(getOrdersSuccess(data));
  } else {
    yield put(getOrdersFailure(response.data.orders));
  }
}

export default all([takeLatest(ActionTypes.getOrdersRequest, getOpenOrders)]);
